import * as v2GridStyles from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Grid/__internal__/GridV2/v2Styles.css";
import { ResponsiveValues } from "@faire/web--source/slate/Theme/ResponsiveValues";

// intended to be used with v2GridStyles.gridFixedLayout
export const getGridFixedLayoutResponsiveStyleVars = (
  responsiveNumberOfColumns: ResponsiveValues<number>
) => {
  const mobileNumberOfColumns = responsiveNumberOfColumns.mobileAndAbove;
  const tabletNumberOfColumns =
    responsiveNumberOfColumns.tabletAndAbove ?? mobileNumberOfColumns;
  const desktopNumberOfColumns =
    responsiveNumberOfColumns.desktopAndAbove ?? tabletNumberOfColumns;
  const xLargeNumberOfColumns =
    responsiveNumberOfColumns.xLargeAndAbove ?? desktopNumberOfColumns;
  return {
    [v2GridStyles.varGridFixedColumnsMobile]: `${mobileNumberOfColumns}`,
    [v2GridStyles.varGridFixedColumnsTablet]: `${tabletNumberOfColumns}`,
    [v2GridStyles.varGridFixedColumnsDesktop]: `${desktopNumberOfColumns}`,
    [v2GridStyles.varGridFixedColumnsXLarge]: `${xLargeNumberOfColumns}`,
  };
};
